import React from "react";
import './classes/SuccessStories.css';

// Resolve an image field to a usable src. The backend may hand us a plain URL
// string, a { url, name } object (as the Blog editor gets), or a freshly
// selected upload wrapper ({ preview }). Anything else (e.g. a bare file id) has
// no renderable URL, so we return "".
const resolveImageSrc = (value) => {
    if (!value) return "";
    if (typeof value === "string") return value;
    if (value.url) return value.url;
    if (value.preview) return value.preview;
    return "";
};

// Read-only detail view for a success story. It can be driven two ways:
//  - by the public Page.js wrapper, which passes the whole `page` object it
//    loaded from pages/getpagedata (fields: body, title, field_image_success_story…)
//  - by EditSuccessStoryPage, which passes already-resolved body/image/title props.
// Earlier this component refetched from an unrelated endpoint
// (smwwagency/retrieveagentmessage) with an undefined `sid` route param and read
// a field that endpoint never returns, so the view always rendered empty.
// Read-only two-column table (name + sort order) with an empty-state message.
const PlacementsTable = ({ label, nameHeader, rows, emptyText }) => (
    <div className="editprofile-fieldset-wrapper" style={{ marginTop: '20px', overflowX: 'auto' }}>
        <label>{label}</label>
        {rows.length > 0 ? (
            <table className="user-profile-summary-table">
                <thead>
                    <tr style={{ borderBottom: '2px solid #eee', textAlign: 'left' }}>
                        <th style={{ padding: '10px' }}>{nameHeader}</th>
                        <th style={{ padding: '10px' }}>Sort Order</th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row, index) => (
                        <tr key={index} style={{ borderBottom: '1px solid #f0f0f0' }}>
                            <td className="user-profile-summary-row" style={{ padding: '10px' }}>
                                <span className="user-profile-value">{row.name}</span>
                            </td>
                            <td className="user-profile-summary-row" style={{ padding: '10px' }}>
                                <span className="user-profile-value">{row.sort}</span>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        ) : (
            <div className="agent-richtext-placeholder empty" style={{ textAlign: 'center', color: '#888' }}>
                <i className="fa fa-exclamation-circle"></i> {emptyText}
            </div>
        )}
    </div>
);

// `placements` ([{ name, sort }]) and `courses` ([{ name, sort }]) are
// admin-only: only EditSuccessStoryPage passes them, so the public page never
// shows placements.
const ViewSuccessStoryPage = ({ page = null, title = "", name = "", body = "", image = "", placements = null, courses = null }) => {
    const resolvedTitle = title || page?.title || "";
    const resolvedName = name || page?.field_name || "";
    const resolvedBody = body || page?.body || "";
    const resolvedImage = resolveImageSrc(image || page?.field_image_success_story);

    return (
        <div>
            <div className="view-agent-msg-container view-success-story">
                {resolvedTitle ? (
                    <h1 className="view-success-story-title">{resolvedTitle}</h1>
                ) : null}
                {resolvedImage || resolvedName ? (
                    <div className="view-success-story-profile">
                        {resolvedImage ? (
                            <div className="view-success-story-image">
                                <img src={resolvedImage} alt={resolvedName || resolvedTitle || "Success story"} />
                            </div>
                        ) : null}
                        {resolvedName ? (
                            <strong className="success-name">{resolvedName}</strong>
                        ) : null}
                    </div>
                ) : null}
                <div dangerouslySetInnerHTML={{ __html: resolvedBody }} />
            </div>
            {placements && (
                <PlacementsTable
                    label="PLACEMENTS"
                    nameHeader="Page"
                    rows={placements}
                    emptyText="This success story is not placed on any page."
                />
            )}
            {courses && (
                <PlacementsTable
                    label="COURSE PLACEMENTS"
                    nameHeader="Course"
                    rows={courses}
                    emptyText="This success story is not placed on any course."
                />
            )}
        </div>
    );
};
export default ViewSuccessStoryPage;
